// COMPONENTS
import text_input from './text/ko-field-input-text.js';
import text_view from './text/ko-field-view-text.js';
import date_input from './date/ko-field-input-date.js';
import date_view from './date/ko-field-view-date.js';
import number_input from './number/ko-field-input-number.js';
import number_view from './number/ko-field-view-number.js';
import phone_input from './phone/ko-field-input-phone.js';
import phone_view from './phone/ko-field-view-phone.js';
import email_input from './email/ko-field-input-email.js';
import email_view from './email/ko-field-view-email.js';
import boolean_input from './boolean/ko-field-input-boolean.js';
import boolean_view from './boolean/ko-field-view-boolean.js';
import address_input from './address/ko-field-input-address.js';
import address_view from './address/ko-field-view-address.js';
import password_input from './password/ko-field-input-password.js';
import password_view from './password/ko-field-view-password.js';
import file_input from './file/ko-field-input-file.js';
import file_view from './file/ko-field-view-file.js';
import url_input from './url/ko-field-input-url.js';
import url_view from './url/ko-field-view-url.js';
import time_input from './time/ko-field-input-time.js';
import time_view from './time/ko-field-view-time.js';
import image_input from './image/ko-field-input-image.js';
import image_view from './image/ko-field-view-image.js';
import json_input from './json/ko-field-input-json.js';
import json_view from './json/ko-field-view-json.js';
import list_input from './list/ko-field-input-list.js';
import list_view from './list/ko-field-view-list.js';
import list_input_multiselect from './list/ko-field-input-multiselect-list.js';
import list_view_multiselect from './list/ko-field-view-multiselect-list.js';
import percentage_input from './percentage/ko-field-input-percentage.js';
import percentage_view from './percentage/ko-field-view-percentage.js';
import currency_input from './currency/ko-field-input-currency.js';
import currency_view from './currency/ko-field-view-currency.js';
import interval_input from './interval/ko-field-input-interval.js';
import interval_view from './interval/ko-field-view-interval.js';
import number_range_input from './number-range/ko-field-input-number-range.js';
import number_range_view from './number-range/ko-field-view-number-range.js';
import date_range_input from './date-range/ko-field-input-date-range.js';
import date_range_view from './date-range/ko-field-view-date-range.js';

export default [
	text_input,
	text_view,
	date_input,
	date_view,
	number_input,
	number_view,
	phone_input,
	phone_view,
	email_input,
	email_view,
	boolean_input,
	boolean_view,
	address_input,
	address_view,
	password_input,
	password_view,
	file_input,
	file_view,
	url_input,
	url_view,
	time_input,
	time_view,
	image_input,
	image_view,
	json_input,
	json_view,
	list_input,
	list_view,
	list_input_multiselect,
	list_view_multiselect,
	percentage_input,
	percentage_view,
	currency_input,
	currency_view,
	interval_input,
	interval_view,
	number_range_input,
	number_range_view,
	date_range_input,
	date_range_view
];
